import cx from 'classnames'

import Styles from './Properties.module.scss'

import { useFinderContext } from 'screens/Finder/FinderContext'

import { Button } from 'components/Button/Button'
import { ReactComponent as ShownIcon } from 'assets/icons/eye16.svg'
import { ReactComponent as HiddenIcon } from 'assets/icons/eyeClosed16.svg'
import { EditableProperty, PropertyVisibility } from './Properties'

type Props = {
  editableProperty: EditableProperty
  onClose: () => void
}

export const ChangeVisibilityButton = ({ editableProperty, onClose }: Props) => {
  const { property, visibility } = editableProperty
  const { removePropertyFromSchema, addPropertyToSchema } = useFinderContext()

  const visibilityButtonData = {
    [PropertyVisibility.Shown]: {
      visibilityIcon: <HiddenIcon className={Styles.icon} />,
      visibilityText: 'Hide in view',
      onVisibilityIconPress: () => {
        removePropertyFromSchema(property.id)
        onClose()
      },
    },
    [PropertyVisibility.Hidden]: {
      visibilityIcon: <ShownIcon className={Styles.icon} />,
      visibilityText: 'Show in view',
      onVisibilityIconPress: () => {
        addPropertyToSchema(property)
        onClose()
      },
    },
  }

  const { visibilityIcon, visibilityText, onVisibilityIconPress } = visibilityButtonData[visibility]

  return (
    <div className={Styles.flexContainer}>
      <Button
        className={cx(Styles.flexContainer, Styles.flexGrow, Styles.horizontalPadding, Styles.columnGap0)}
        variant="tertiary"
        size="lg"
        onPress={onVisibilityIconPress}
      >
        {visibilityIcon}
        <div>{visibilityText}</div>
      </Button>
    </div>
  )
}
